// Okno po přidání do košíku (Rozšířená objednávka): fotka, název a cena přidaného produktu
// a pod tím až 3 doporučení z „Podobných produktů“ přidaného produktu.
// Vysvětlení u doporučení = doplňkový parametr „Upsell text“ doporučeného produktu.
const myUpsell = {
    texts: null,
    lastAdd: null,
    pending: null,
    requests: {},
    upsellTexts: {},
    maxItems: 3,
    cacheMinutes: 15,
};

function myUpsellTexts() {
    if (!myUpsell.texts) {
        myUpsell.texts = $.extend({
            title: "Mohlo by se vám hodit",
            addToCart: "Přidat do košíku",
            added: "Přidáno do košíku",
            failed: "Nepodařilo se přidat",
            detail: "Vybrat variantu",
            parameter: "Upsell text",
        }, (typeof shopDataLayer !== "undefined" && shopDataLayer.addToCartUpsell) || {});
    }

    return myUpsell.texts;
}

function myUpsellPath(url) {
    try {
        return new URL(url, window.location.origin).pathname;
    } catch (e) {
        return "";
    }
}

function myUpsellEscape(text) {
    return $("<div></div>").text(text || "").html();
}

function myUpsellFormatPrice(value) {
    const info = getShoptetDataLayer("currencyInfo") || {};
    const decimals = typeof info.priceDecimalPlaces === "number" ? info.priceDecimalPlaces : 0;

    if (!info.symbol || typeof value !== "number") {
        return "";
    }

    // Stejný zápis jako ceny Shoptetu na webu (€20,49 / 1 049 Kč) – podle currencyInfo, ne podle Intl
    const parts = value.toFixed(value % 1 === 0 ? 0 : decimals).split(".");
    const number = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, info.thousandSeparator || " ") + (parts[1] ? (info.decimalSeparator || ",") + parts[1] : "");

    return info.symbolLeft ? info.symbol + number : number + " " + info.symbol;
}

// Data karty produktu (výpis, Podobné produkty)
function myUpsellCard($p) {
    const $form = $p.find("form.pr-action").first();
    const $img = $p.find("a.image img").first();

    return {
        id: String($p.attr("data-micro-product-id") || ""),
        url: myUpsellPath($p.find("a.name").attr("href") || $p.find("a.image").attr("href")),
        name: $p.find("[data-micro='name']").first().text().trim() || $p.find("a.name").text().trim(),
        image: ($img.attr("data-src") || $img.attr("src") || "").trim(),
        alt: $img.attr("alt") || "",
        price: $p.find(".price-final strong").first().text().trim(),
        priceId: $p.attr("data-myupsell-price-id") || $form.find("input[name='priceId']").val() || "",
        amount: $form.find("input[name='amount']").val() || 1,
    };
}

// Řádek doplňkového parametru „Upsell text“
function myUpsellParamRows($scope) {
    const name = myUpsellTexts().parameter.toLowerCase();

    return $scope.find(".detail-parameters tr").filter(function () {
        return $(this).children("th").text().replace(/[\s:]+$/, "").trim().toLowerCase() === name;
    });
}

function myUpsellParse(doc) {
    const alternatives = [];
    const seen = {};

    $(doc).find("#productsAlternative .p[data-micro-product-id], .product-upsell .p[data-micro-product-id]").each(function () {
        const card = myUpsellCard($(this));
        if (card.id && card.url && !seen[card.id]) {
            seen[card.id] = true;
            alternatives.push(card);
        }
    });

    return {
        alternatives: alternatives,
        text: myUpsellParamRows($(doc)).first().children("td").text().replace(/\s+/g, " ").trim(),
    };
}

// /cache/ vrací ceny ve výchozí měně (CZK) bez ohledu na měnu zákazníka
function myUpsellNeedsSession() {
    return (getShoptetDataLayer("currency") || "CZK") !== "CZK";
}

// Načtení detailu produktu, paměť v rámci stránky i sessionStorage
// session = bez /cache/ (ceny v měně zákazníka); smí běžet až po dokončení GetExtendedOrder
function myUpsellLoad(path, textOnly, session) {
    const key = "myUpsell:" + getShoptetDataLayer("currency") + ":" + (textOnly ? "text" : "full") + ":" + path;

    if (myUpsell.requests[key]) {
        return myUpsell.requests[key];
    }

    try {
        const stored = JSON.parse(sessionStorage.getItem(key) || "null");
        if (stored && Date.now() - stored.time < myUpsell.cacheMinutes * 60000) {
            myUpsell.requests[key] = Promise.resolve(stored.data);
            return myUpsell.requests[key];
        }
    } catch (e) {}

    myUpsell.requests[key] = new Promise(function (resolve) {
        $.get((session ? "" : "/cache") + path, function (html) {
            const data = myUpsellParse(shoptet.common.createDocumentFromString(html));
            try {
                sessionStorage.setItem(key, JSON.stringify({ time: Date.now(), data: data }));
            } catch (e) {}
            resolve(data);
        }, "html").fail(function () {
            delete myUpsell.requests[key];
            resolve({ alternatives: [], text: "" });
        });
    });

    return myUpsell.requests[key];
}

function myUpsellText(path) {
    if (Object.prototype.hasOwnProperty.call(myUpsell.upsellTexts, path)) {
        return Promise.resolve(myUpsell.upsellTexts[path]);
    }

    return myUpsellLoad(path, true).then(function (data) {
        myUpsell.upsellTexts[path] = data.text;
        return data.text;
    });
}

// Odkud se přidávalo: karta produktu, nebo detail
function myUpsellContext(form) {
    if (!form || !form.isConnected) {
        return null;
    }

    const $form = $(form);
    const $card = $form.closest(".p[data-micro-product-id]");
    const context = {
        priceId: String($form.find("input[name='priceId']").val() || ""),
        amount: parseFloat($form.find("input.amount, input[name='amount']").first().val()) || 1,
    };

    if ($card.length) {
        const card = myUpsellCard($card);
        return $.extend(context, {
            id: card.id,
            url: card.url,
            image: card.image,
            price: card.price,
            current: false,
        });
    }

    if ($("body").hasClass("type-detail")) {
        const product = getShoptetDataLayer("product") || {};
        const $image = $(".p-image .p-main-image img, .p-image img").first();
        return $.extend(context, {
            id: String(product.id || ""),
            url: window.location.pathname,
            image: $image.attr("src") || $image.attr("data-src") || $("meta[property='og:image']").attr("content") || "",
            price: $(".p-final-price-wrapper .price-final-holder").not(".no-display").first().text().trim(),
            current: true,
        });
    }

    return null;
}

// Doporučení bez přidaného produktu a bez toho, co už je v košíku
function myUpsellPick(context, alternatives) {
    const inCart = {};
    $.each(getShoptetDataLayer("cart") || [], function (index, item) {
        inCart[String(item.priceId)] = true;
    });

    return alternatives.filter(function (card) {
        return card.id !== context.id && !(card.priceId && inCart[card.priceId]);
    }).slice(0, myUpsell.maxItems);
}

function myUpsellPreloadTexts(context) {
    context.ready.then(function (alternatives) {
        alternatives.filter(function (card) {
            return card.id !== context.id;
        }).slice(0, myUpsell.maxItems + 1).forEach(function (card) {
            myUpsellText(card.url);
        });
    });
}

function myUpsellPrepare(context) {
    if (context.current) {
        context.alternatives = myUpsellParse(document).alternatives;
        context.ready = Promise.resolve(context.alternatives);
    } else if (myUpsellNeedsSession()) {
        // Jiná měna: detail se stáhne v session až po otevření okna (souběh s GetExtendedOrder okno rozbíjí)
        context.deferred = true;
        return;
    } else {
        context.ready = myUpsellLoad(context.url, false).then(function (data) {
            context.alternatives = data.alternatives;
            return data.alternatives;
        });
    }

    // Vysvětlení se načítají hned po kliknutí, okno se otevírá až po odpovědi košíku
    myUpsellPreloadTexts(context);
}

function myUpsellResize() {
    if (shoptet.modal && typeof shoptet.modal.shoptetResize === "function") {
        shoptet.modal.shoptetResize();
    }
}

// Fotka, název a cena přidaného produktu
function myUpsellAdded($order, context) {
    const $name = $order.children(".h2").first();
    if (!$name.length || $order.find(".myadded").length) {
        return;
    }

    // Shoptet dává do názvu i doplněk názvu a vybranou variantu; varianta jde drobně pod název
    const variant = $name.children("span").not(".product-appendix").text().replace(/\s+/g, " ").trim();
    $name.children("span").remove();

    let price = context.price;
    const item = (getShoptetDataLayer("cart") || []).filter(function (cartItem) {
        return context.priceId && String(cartItem.priceId) === context.priceId;
    })[0];
    if (item && typeof item.priceWithVat === "number") {
        price = myUpsellFormatPrice(item.priceWithVat) || price;
    }

    const $added = $("<div class='myadded'>" +
        "<div class='myadded-image'></div>" +
        "<div class='myadded-info'>" +
            "<div class='myadded-price'>" + (context.amount > 1 ? context.amount + " × " : "") + myUpsellEscape(price) + "</div>" +
        "</div>" +
    "</div>");

    if (context.image) {
        $added.find(".myadded-image").append($("<img>").attr({ src: context.image, alt: $name.text().trim(), width: 80, height: 80 }));
    } else {
        $added.find(".myadded-image").remove();
    }

    if (!price) {
        $added.find(".myadded-price").remove();
    }

    if (variant) {
        $("<div class='myadded-variant'></div>").text(variant).insertBefore($added.find(".myadded-price"));
    }

    $added.insertBefore($name);
    $name.prependTo($added.find(".myadded-info"));
    $order.addClass("has-myadded");
}

function myUpsellItem(card) {
    const texts = myUpsellTexts();
    const known = Object.prototype.hasOwnProperty.call(myUpsell.upsellTexts, card.url);
    const text = known ? myUpsell.upsellTexts[card.url] : "";
    let action = "<a class='myupsell-detail' href='" + myUpsellEscape(card.url) + "'>" + texts.detail + "</a>";

    if (card.priceId) {
        action = "<button type='button' class='myupsell-add' data-price-id='" + myUpsellEscape(card.priceId) + "' data-amount='" + myUpsellEscape(String(card.amount)) + "'>" + texts.addToCart + "</button>";
    }

    const $item = $("<div class='myupsell-item' data-url='" + myUpsellEscape(card.url) + "'>" +
        "<a class='myupsell-image' href='" + myUpsellEscape(card.url) + "' tabindex='-1'></a>" +
        "<div class='myupsell-info'>" +
            "<a class='myupsell-name' href='" + myUpsellEscape(card.url) + "'>" + myUpsellEscape(card.name) + "</a>" +
            (known ? (text ? "<p class='myupsell-text'>" + myUpsellEscape(text) + "</p>" : "") : "<p class='myupsell-text is-loading' aria-hidden='true'></p>") +
        "</div>" +
        "<div class='myupsell-buy'>" +
            "<div class='myupsell-price'>" + myUpsellEscape(card.price) + "</div>" +
            action +
        "</div>" +
    "</div>");

    if (card.image) {
        $item.find(".myupsell-image").append($("<img>").attr({ src: card.image, alt: card.alt || card.name, width: 72, height: 72, loading: "lazy" }));
    }

    if (!known) {
        myUpsellText(card.url).then(function (loaded) {
            const $text = $item.find(".myupsell-text.is-loading");
            if (loaded) {
                $text.removeClass("is-loading").removeAttr("aria-hidden").text(loaded);
            } else {
                $text.remove();
            }
            myUpsellResize();
        });
    }

    return $item;
}

// Zástupný blok, než se doplní doporučení stažená až po otevření okna
function myUpsellSkeleton($order) {
    const $upsell = $("<div class='myupsell is-loading' aria-hidden='true'>" +
        "<div class='myupsell-title'>" + myUpsellTexts().title + "</div>" +
        "<div class='myupsell-list'></div>" +
    "</div>");

    for (let i = 0; i < myUpsell.maxItems; i++) {
        $upsell.find(".myupsell-list").append("<div class='myupsell-item'>" +
            "<span class='myupsell-image'></span>" +
            "<div class='myupsell-info'>" +
                "<p class='myupsell-text is-loading'></p>" +
                "<p class='myupsell-text is-loading'></p>" +
            "</div>" +
        "</div>");
    }

    $order.append($upsell);
    myUpsellResize();
}

function myUpsellRender($order, context, alternatives) {
    const picked = myUpsellPick(context, alternatives);
    $order.find(".myupsell.is-loading").remove();
    if (!picked.length || !$order[0].isConnected || $order.find(".myupsell").length) {
        myUpsellResize();
        return;
    }

    const $upsell = $("<div class='myupsell'>" +
        "<div class='myupsell-title'>" + myUpsellTexts().title + "</div>" +
        "<div class='myupsell-list'></div>" +
    "</div>");

    picked.forEach(function (card) {
        $upsell.find(".myupsell-list").append(myUpsellItem(card));
    });

    $order.append($upsell);
    myUpsellResize();
}

// Hláška o dopravě zdarma podle aktuálního košíku (text i hranice ze Shoptetu)
function myUpsellRefreshShipping() {
    const $extras = $(".advanced-order .extras-wrap");
    if (!$extras.length) {
        return;
    }

    shoptet.ajax.makeAjaxRequest(shoptet.config.advancedOrderUrl, shoptet.ajax.requestTypes.get, "", {
        success: function (response) {
            const content = response.getFromPayload("content");
            const $fresh = content ? $("<div>" + content + "</div>").find(".extras-wrap").first() : $();
            if ($fresh.length && $extras[0].isConnected) {
                $extras.replaceWith($fresh);
                myUpsellResize();
            }
        },
    });
}

$(document).ready(function () {
    // Na detailu je parametr „Upsell text“ jen podklad pro okno košíku, zákazník ho v parametrech nevidí
    if ($("body").hasClass("type-detail")) {
        // Doporučení leží uvnitř formuláře detailu a Shoptet jim při výběru varianty přepíše priceId na priceId varianty
        $(".p[data-micro-product-id]").each(function () {
            const priceId = $(this).find("input[name='priceId']").first().val();
            if (priceId) {
                $(this).attr("data-myupsell-price-id", priceId);
            }
        });

        myUpsellParamRows($(document)).addClass("no-display");
        // Shoptet k doplňkovým parametrům přidá řádek „Kategorie“ – sám o sobě blok nedrží, jinak se popis zúží na polovinu
        const categoryHrefs = $(".breadcrumbs a[href], .breadcrumb a[href]").map(function () {
            return $(this).attr("href").replace(/^https?:\/\/[^/]+/, "");
        }).get();

        $(".extended-description").each(function () {
            const $visibleRows = $(this).find(".detail-parameters tr").not(".no-display").filter(function () {
                const href = ($(this).find("td a[href]").first().attr("href") || "").replace(/^https?:\/\/[^/]+/, "");
                return !href || !categoryHrefs.includes(href);
            });

            if ($visibleRows.length === 0) {
                $(this).addClass("no-display");
            }
        });
    }
});

// Přidání do košíku nativním tlačítkem (ne tiché přidání z našeho okna)
document.addEventListener("shoptet.cart.ajaxSubmitForm", function () {
    const args = shoptet.scripts.arguments["shoptet.cart.ajaxSubmitForm"];
    if (!args || args[0] !== shoptet.config.addToCartUrl || !args[4]) {
        return;
    }

    const context = myUpsellContext($(args[1])[0]);
    myUpsell.lastAdd = context;
    if (context && context.url) {
        myUpsellPrepare(context);
    }
});

document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
    const $order = $(".advanced-order").first();
    const context = myUpsell.lastAdd;
    myUpsell.lastAdd = null;

    // Okno košíku ve střední šířce Shoptetu místo široké (1152 px), obsah je jednosloupcový
    if ($order.length && shoptet.modal && shoptet.modal.config) {
        $("#colorbox").removeClass(shoptet.modal.config.classLg).addClass(shoptet.modal.config.classMd);
        myUpsellResize();
    }

    if (!$order.length || !context) {
        return;
    }

    myUpsellAdded($order, context);
    myUpsellResize();

    if (context.alternatives) {
        myUpsellRender($order, context, context.alternatives);
    } else if (context.deferred) {
        myUpsellSkeleton($order);
        context.ready = myUpsellLoad(context.url, false, true).then(function (data) {
            context.alternatives = data.alternatives;
            return data.alternatives;
        });
        myUpsellPreloadTexts(context);
        context.ready.then(function (alternatives) {
            myUpsellRender($order, context, alternatives);
        });
    } else if (context.ready) {
        context.ready.then(function (alternatives) {
            myUpsellRender($order, context, alternatives);
        });
    }
});

function myUpsellCartAmount(priceId) {
    let amount = 0;
    $.each(getShoptetDataLayer("cart") || [], function (index, item) {
        if (String(item.priceId) === String(priceId)) {
            amount += parseFloat(item.quantity) || 0;
        }
    });

    return amount;
}

function myUpsellDone(added) {
    const $button = myUpsell.pending.button;
    myUpsell.pending = null;
    $button.removeClass("is-loading");

    if (added) {
        $button.addClass("is-added").text(myUpsellTexts().added);
        myUpsellRefreshShipping();
    } else {
        $button.prop("disabled", false).text(myUpsellTexts().failed);
    }
}

$(document).on("click", ".myupsell-add", function () {
    const $button = $(this);
    if (myUpsell.pending || $button.hasClass("is-added")) {
        return;
    }

    const priceId = $button.data("price-id");
    myUpsell.pending = { button: $button, priceId: priceId, before: myUpsellCartAmount(priceId) };
    $button.addClass("is-loading").prop("disabled", true);
    shoptet.cartShared.addToCart({ priceId: priceId, amount: $button.data("amount") || 1 }, true);
});

// Shoptet pošle ShoptetCartUpdated i po neúspěšném přidání, úspěch se pozná podle množství v košíku
document.addEventListener("ShoptetCartUpdated", function () {
    if (myUpsell.pending) {
        myUpsellDone(myUpsellCartAmount(myUpsell.pending.priceId) > myUpsell.pending.before);
    }
});

document.addEventListener("ShoptetCartAddCartItemFailed", function () {
    if (myUpsell.pending) {
        myUpsellDone(false);
    }
});
